import toast from "./toast.function";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { clearToken, getToken } from "@/functions/token.function";
import router from "@/router";
import { GuestPages } from "@/constants/guest.constant";

export const errorResponseHandler = (error: AxiosError): any => {
  if (error.response) {
    const { response } = error;
    const message = response.data.message;
    if (
      !GuestPages.includes(router.currentRoute.name as string) ||
      message !== "Unauthenticated."
    ) {
      toast.error(message);
    }
    if (response.data.status === 401) clearToken();
  }
  throw error;
};

export const responseHandler = (response: AxiosResponse): AxiosResponse => {
  return response;
};

export const requestHandler = (
  config: AxiosRequestConfig
): AxiosRequestConfig => {
  config.headers.authorization = `Bearer ${getToken()}`;
  return config;
};
